var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.notShowTooltip ? "" : _vm.tooltip,
          expression: "notShowTooltip ? '' : tooltip",
        },
      ],
      staticClass:
        "w-6 h-6 rounded transition-all flex justify-center items-center hover:bg-gray-100",
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "svg",
        {
          staticClass: "w-3 h-3",
          attrs: {
            viewBox: "0 0 170.08 170.08",
            "xml:space": "preserve",
            fill: _vm.fillColor,
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M103.071,85.04l63.273-63.273c4.981-4.979,4.981-13.052,0-18.031c-4.981-4.981-13.05-4.981-18.031,0\n      L85.04,67.009L21.767,3.736c-4.981-4.981-13.049-4.981-18.031,0c-4.981,4.979-4.981,13.052,0,18.031L67.009,85.04L3.736,148.313\n      c-4.981,4.979-4.981,13.052,0,18.031c2.491,2.49,5.753,3.736,9.016,3.736c3.262,0,6.525-1.246,9.015-3.736L85.04,103.07\n      l63.273,63.274c2.491,2.49,5.753,3.736,9.015,3.736c3.263,0,6.525-1.246,9.016-3.736c4.981-4.979,4.981-13.052,0-18.031\n      L103.071,85.04z",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }